import React, { useEffect } from 'react';
import { trackPixel, trackAndNavigate } from '../utils/pixel';
const PLAN_VALUE = 29990;
export function Pricing() {
  useEffect(() => {
    const section = document.getElementById('pricing-section');
    if (!section) return;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        trackPixel('ViewContent', {
          content_name: 'Pricing Section',
          content_category: 'Nutrición Resuelta'
        });
        observer.disconnect();
      }
    }, {
      threshold: 0.3
    });
    observer.observe(section);
    return () => observer.disconnect();
  }, []);
  const checkoutUrl = 'https://bibliotecaprofesional.impultienda.ar/checkout';
  return <section id="pricing-section" className="w-full px-4 sm:px-6 lg:px-8 py-12 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(254,242,242) 0%, rgb(248,250,252) 8%, rgb(248,250,252) 85%, rgb(240,253,244) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-159">
      <div className="mx-auto max-w-2xl" data-id="element-160">
        <div className="text-center mb-5" data-id="element-161">
          <div className="inline-flex items-center gap-2 text-[11px] font-bold tracking-wide rounded-full px-4 py-1.5 mb-4" style={{
          color: 'rgb(21,128,61)',
          border: '1px solid rgba(34,197,94,0.40)',
          backgroundColor: 'rgba(34,197,94,0.05)'
        }} data-id="element-162">
            🔥 Precio de lanzamiento activo
          </div>

          <h2 className="sm:text-3xl font-black text-gray-900 m-0 text-[23px]" data-id="element-163">
            Todo lo que necesitás para dejar de improvisar consultas
          </h2>
        </div>

        <div className="rounded-2xl bg-white border-2 border-green-700 shadow-xl overflow-hidden" data-id="element-164">
          <div className="bg-green-700 px-5 py-3 text-center" data-id="element-165">
            <p className="text-xs font-black text-white/80 uppercase tracking-[2px] m-0" data-id="element-166">
              Megapack Nutrición Resuelta
            </p>
          </div>

          <div className="px-5 py-5 text-center" data-id="element-167">
            <h3 className="text-xl sm:text-2xl font-black text-gray-900 m-0 mb-2" data-id="element-168">
              6 Tomos + 5 Bonos Profesionales
            </h3>

            <p className="text-sm font-semibold text-gray-600 m-0 mb-4" data-id="element-169">
              Para ordenar tus consultas, mejorar seguimientos y trabajar con
              más claridad, tiempo y seguridad.
            </p>

            <div className="mb-3 text-center" data-id="element-170">
              <p className="text-[10px] uppercase tracking-widest text-gray-400 font-black m-0 mb-1" data-id="element-171">
                Valor real
              </p>

              <p className="text-2xl sm:text-3xl text-gray-400 line-through font-black m-0 mb-2" data-id="element-172">
                $64.990
              </p>

              <p className="text-[10px] uppercase tracking-widest text-green-700 font-black m-0 mb-1" data-id="element-173">
                Precio de lanzamiento
              </p>

              <p className="text-6xl sm:text-7xl font-black text-green-700 leading-none m-0" data-id="element-174">
                $22.990
              </p>
            </div>

            <p className="text-sm font-black text-green-700 m-0 mb-4" data-id="element-175">
              Ahorrás $42.000 hoy
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-left" data-id="element-176">
              {['6 tomos completos en PDF', '5 bonos profesionales incluidos', '+350 páginas de contenido', 'Sistema para ordenar consultas', 'Acceso inmediato', 'Garantía de 7 días'].map(item => <div key={item} className="flex items-center gap-2 rounded-lg bg-green-50 px-3 py-2" data-id="element-177">
                  <span className="text-green-700 font-black" data-id="element-178">✓</span>
                  <span className="text-xs font-bold text-gray-800" data-id="element-179">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>

        <a href={checkoutUrl} onClick={e => {
        e.preventDefault();
        trackAndNavigate('InitiateCheckout', {
          content_name: 'Megapack Nutrición Resuelta',
          content_category: 'Nutrición Resuelta',
          value: PLAN_VALUE,
          currency: 'ARS'
        }, checkoutUrl);
      }} className="cta-breathe mt-6 block w-full bg-green-700 text-white text-center text-xl sm:text-2xl font-black uppercase tracking-wide rounded-2xl px-6 py-7 no-underline transition-colors hover:bg-green-800" data-id="element-180">
          🥑 QUIERO MI MEGAPACK AHORA
        </a>

        <div className="mt-4 flex flex-nowrap items-center justify-center gap-1.5 sm:gap-2" data-id="element-181">
          {[{
          icon: '🔒',
          label: 'Pago seguro'
        }, {
          icon: '⚡',
          label: 'Acceso inmediato'
        }, {
          icon: '💳',
          label: 'Mercado Pago'
        }].map(({
          icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1 sm:gap-1.5 whitespace-nowrap rounded-full bg-white px-2.5 sm:px-3.5 py-2 text-[11px] sm:text-sm font-bold text-gray-700 shadow-sm" style={{
          border: '1px solid rgba(21,128,61,0.30)'
        }} data-id="element-182">
              <span className="text-sm sm:text-base" data-id="element-183">{icon}</span>
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}